import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import ticksImg from '@/assets/our-history/history-icons/ticks.png'

import styles from './History.module.scss'

const History = ({ year, title, description, icon = ticksImg }) => (
  <div className={`text-center rows gap-18 bgcolor-background ${styles.wrapper}`}>
    <h2 className={styles.year}>{year}</h2>
    <h3 className={styles.title}>{title}</h3>
    <div className={styles.separator}>&nbsp;</div>
    <p className={styles.description}>{description}</p>
    <Image
      alt=""
      className="image-center"
      src={icon}
      style={{ height: 'auto' }}
      width={82}
    />
  </div>
)

History.propTypes = {
  year: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default History
